<rl-dialog-window (onConfirm)="confirm()" (onCancel)="cancel()" [title]="'winDialog.delete'">
    <span [innerHtml]="message"></span>
</rl-dialog-window>